import React from "react";

// Centred "nothing here" block for tables and panels: round icon badge, title, one hint line.
// Use inside a table cell (colSpan) or a panel body.
const EmptyState = ({ icon: Icon, title, text }) => (
  <div className="flex flex-col items-center justify-center gap-1.5 py-8 px-4 text-center">
    {Icon && (
      <span className="flex items-center justify-center w-12 h-12 rounded-full bg-slate-100 border border-[#cbd5e1] text-[#313C4C]">
        <Icon size={22} />
      </span>
    )}
    <p className="m-0 text-[13px] font-medium text-slate-900">{title}</p>
    {text && <p className="m-0 max-w-sm text-[11px] text-slate-500">{text}</p>}
  </div>
);

export default EmptyState;
